import { useEffect } from 'react'
import { useToastStore, type Toast as ToastModel } from '@/stores/toast'

const AUTO_DISMISS_MS = 6_000

const KIND_STYLES: Record<ToastModel['kind'], string> = {
  error: 'border-loss bg-loss/10 text-loss',
  success: 'border-gain bg-gain/10 text-gain',
  info: 'border-bernstein bg-bernstein/10 text-bernstein',
}

interface ToastItemProps {
  toast: ToastModel
}

function ToastItem({ toast }: ToastItemProps) {
  const dismissToast = useToastStore((s) => s.dismissToast)

  useEffect(() => {
    const timer = setTimeout(() => dismissToast(toast.id), AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
  }, [toast.id, dismissToast])

  return (
    <div
      role="alert"
      className={`hairline pointer-events-auto flex max-w-md items-start gap-3 border bg-panel px-4 py-3 text-sm ${KIND_STYLES[toast.kind]}`}
    >
      <div className="flex-1">
        <p className="font-medium">{toast.message}</p>
        {toast.detail && <p className="mt-1 text-xs text-muted">{toast.detail}</p>}
      </div>
      <button
        type="button"
        onClick={() => dismissToast(toast.id)}
        aria-label="Schließen"
        className="text-muted transition-colors hover:text-ink"
      >
        ×
      </button>
    </div>
  )
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)

  if (toasts.length === 0) return null

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  )
}
